import React, { useEffect, useState } from "react"
import { Card, CardBody, Col } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "./ChartsDynamicColor"

export default function CardUser(props) {
  console.log(props)
  const apexCardUserChartColors = getChartColorsArray(props.dataColors)
  const [histogram, setHistogram] = useState([])

  useEffect(() => {
    if (props && props.data.histogram) {
      setHistogram(props.data.histogram)
    }
  }, [props])

  const series = [
    {
      name: "Pageviews",
      data: histogram.map(entry => entry.pageviews),
    },
    {
      name: "Visitors",
      data: histogram.map(entry => entry.visitors),
    },
  ]

  const options = {
    chart: {
      height: 350,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    colors: apexCardUserChartColors,
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    xaxis: {
      categories: histogram.map(entry => entry.date),
    },
    markers: {
      size: 3,
      strokeWidth: 3,
      hover: {
        size: 4,
        sizeOffset: 2,
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
    },
  }

  return (
    <React.Fragment>
      <Col xl={12}>
        <Card>
          <CardBody>
            <div className="d-flex flex-wrap">
              <h5 className="card-title me-2">Visitors</h5>
            </div>
            <hr className="mb-4" />
            <div id="area-chart" dir="ltr">
              <ReactApexChart
                options={options}
                series={series}
                type="area"
                height={350}
                className="apex-charts"
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}
